module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.brand_delivery_times), function(brand_delivery_time) {
    return _c('tr', {
      key: brand_delivery_time.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(brand_delivery_time.brand))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_times[brand_delivery_time.id]),
        expression: "delivery_times[brand_delivery_time.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.delivery_times[brand_delivery_time.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.delivery_times, brand_delivery_time.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateBrandDeliveryTimeField(brand_delivery_time.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Merk levertijd")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Merk")]), _vm._v(" "), _c('th', [_vm._v("Levertijd (in weken)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26913182","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/settings/BrandDeliveryTimeTab.vue
// module id = 700
// module chunks = 1